export default "__VITE_ASSET__d6c04723__"